import type { TranslationsByLanguage } from '@susu/i18n'

import da from './da.json'
import de from './de.json'
import en from './en.json'
import es from './es.json'
import fi from './fi.json'
import fr from './fr.json'
import it from './it.json'
import ko from './ko.json'
import nl from './nl.json'
import pl from './pl.json'
import sv from './sv.json'
import zh from './zh.json'

/**
 * Every language Crowdin publishes for project 99 (source: `en.json`).
 *
 * `@susu/i18n` falls back to English per key, so a locale missing a string
 * renders that one string in English rather than failing — which also means a
 * dropped key is invisible at runtime. `locales.test.ts` guards the parity.
 */
export const translations: TranslationsByLanguage = {
  da,
  de,
  en,
  es,
  fi,
  fr,
  it,
  ko,
  nl,
  pl,
  sv,
  zh,
}

export const supportedLanguages = Object.keys(translations)
